import * as React from 'react';
import { Group } from '@visx/group';
import { Label } from './Label';
import { MiniBarGraph } from './MiniBarGraph';
import { typedMemo } from '../../../utils/components/typedMemo';
import { TrackArea } from '../../TrackArea';
var MemoedMiniBar = typedMemo(MiniBarGraph);
var MemoedTrackArea = typedMemo(TrackArea);
// renders multiple minibargraphs
export function MiniBarGroup(props) {
    var scalesMap = props.scalesMap, accessors = props.accessors, _a = props.meta, meta = _a === void 0 ? {} : _a, barHeight = props.barHeight, rowHeight = props.rowHeight;
    var series = React.useMemo(function () { return Object.values(props.series); }, [
        props.series
    ]);
    return (React.createElement(React.Fragment, null, series.map(function (s, i) {
        var _a;
        var key = accessors.key(s);
        return (React.createElement(Group, { transform: "translate(0, " + i * rowHeight + ")", key: key },
            React.createElement(MemoedMiniBar, { series: props.series[key], accessors: accessors, scalesMap: scalesMap, barHeight: barHeight, fill: props.colorScheme(key) }),
            React.createElement("foreignObject", { y: barHeight, width: "300px", height: "1px", overflow: "visible" },
                React.createElement(Label, { label: accessors.name(s), subLabel: (_a = accessors.group) === null || _a === void 0 ? void 0 : _a.call(accessors, s), active: true, color: props.colorScheme(key) })),
            React.createElement(MemoedTrackArea, { height: barHeight, series: props.series[key], xScale: scalesMap[key].xScale, accessors: accessors, meta: meta, tooltip: props === null || props === void 0 ? void 0 : props.tooltip, colorScheme: props.colorScheme, ignoreVertical: true })));
    })));
}
//# sourceMappingURL=MiniBarGroup.js.map